"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWifiPaidInHollRub = function SvgWifiPaidInHollRub(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wifi-paid-in-holl-rub_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67 6.223c.74-.14 1.553-.223 2.44-.223.877 0 1.674.081 2.396.217a2 2 0 0 0 .738-3.932A16.957 16.957 0 0 0 12.11 2c-1.14 0-2.2.107-3.18.292a2 2 0 1 0 .74 3.93Zm11.448-1.48a2 2 0 1 0-2.31 3.265 9.1 9.1 0 0 1 1.256 1.063 5.678 5.678 0 0 1 .33.37l.003.004a2 2 0 0 0 3.215-2.38L22 8.25a238.701 238.701 0 0 0 1.611-1.185l-.001-.002-.003-.003-.006-.008-.015-.02a4.213 4.213 0 0 0-.178-.222 9.66 9.66 0 0 0-.477-.527 13.035 13.035 0 0 0-1.813-1.54ZM5.243 8.04a2 2 0 0 0-2.26-3.3 13.837 13.837 0 0 0-1.854 1.512 10.237 10.237 0 0 0-.632.675l-.043.053L.438 7l-.006.007-.002.003-.002.003a2 2 0 0 0 3.136 2.483l.005-.006a6.259 6.259 0 0 1 .357-.378c.28-.275.72-.663 1.317-1.072ZM.428 7.014 2 8.25.428 7.014Zm5.963 12.12c0 .952.939 1.29 1.23 1.29h.694c0 .927.442 1.33 1.587 1.33s1.504-.444 1.504-1.33h2.185c.293 0 1.04-.332 1.04-1.29 0-.957-.748-1.196-1.04-1.196h-2.185v-.873h2.185c2.463 0 4.048-1.717 4.048-4.138 0-2.484-1.424-4.173-3.766-4.173h-3.88c-1.36 0-1.678.722-1.678 2.005v3.677h-.693c-.302 0-1.26.274-1.26 1.298s.958 1.33 1.26 1.33h.693v.874h-.693c-.292 0-1.23.245-1.23 1.197Zm6.787-4.698h-1.772v-2.909h1.803c1.35 0 1.52.822 1.52 1.446 0 .623-.17 1.463-1.55 1.463Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi-paid-in-holl-rub_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWifiPaidInHollRub);
var _default = exports["default"] = Memo;